import React from "react";
import { Grid } from "@material-ui/core";
import { addMonths } from "date-fns";

import {
  Header,
  TakeawaySection,
  SolidSeparator,
  LoanTermsTable,
  NetCostSection,
  BreakevenAnalysis,
  RefinanceAnalysis
} from "..";
import "./styles.css";

const Template = props => {
  const {
    efLoanAmount = 100,
    nfRate = 0.03,
    efRate = 0.08,
    nfLoanTerm = 120,
    efStartDate = new Date(),
    efLoanTerm = 180,
    dealId = 12
  } = props.values || {};

  const {
    companyName = "LoanBoss",
    companyPrimaryColor,
    companySecondaryColor,
    companyAccentColor,
    textColor = "#FFFFFF",
    refiType,
    calculations = {}
  } = props;

  const getEfMaturityDate = () => {
    if (efStartDate === "" || efLoanTerm === "") {
      return null;
    }

    return addMonths(efStartDate, efLoanTerm);
  };

  const {
    treasury = 0.1,
    breakevenTreasury = 0.18,
    prepaymentPenalty = 1000,
    costSavingsResult = 100,
    netCashout = 0,
    closingCosts = 0,
    newLoanAmount = 10000,
    dealName = "Default Deal"
  } = calculations;

  const Table = () => (
    <LoanTermsTable
      companyPrimaryColor={companyPrimaryColor}
      companySecondaryColor={companySecondaryColor}
      companyAccentColor={companyAccentColor}
      efLoanAmount={efLoanAmount}
      nfLoanAmount={newLoanAmount}
      efRate={efRate}
      nfRate={nfRate}
      nfLoanTerm={nfLoanTerm}
      efStartDate={efStartDate}
      efMaturityDate={getEfMaturityDate()}
      prepaymentPenalty={prepaymentPenalty}
      closingCosts={closingCosts}
      cashOut={netCashout}
      refiType={refiType}
    />
  );

  const TableSection = () => (
    refiType === "Refi Breakeven" ?
      <Grid container item xs={11} className="pdf-export-loan-terms-net-cost-wrapper" alignItems="center" style={{ border: `0.5px solid ${companyPrimaryColor}` }}>
        <Table />
        <NetCostSection
          companyPrimaryColor={companyPrimaryColor}
          prepaymentPenalty={prepaymentPenalty}
          interestSavings={costSavingsResult}
        />
      </Grid> :
      <Table />
  );

  return (
    <div className="pdf-export-wrapper">
      <Grid container style={{ maxWidth: "1063px" }} justify="center">
        <Header
          companyPrimaryColor={companyPrimaryColor}
          companyName={companyName}
          textColor={textColor}
          refiType={refiType}
          dealId={dealId}
          dealName={dealName}
        />
        <TakeawaySection
          {...calculations}
          companyPrimaryColor={companyPrimaryColor}
          companySecondaryColor={companySecondaryColor}
          breakevenPercent={breakevenTreasury}
          tenYearTreasuryYield={treasury}
          refiType={refiType}
          maturityDate={getEfMaturityDate()}
        />
        <SolidSeparator companyPrimaryColor={companyPrimaryColor} />
        <TableSection />
        {
          refiType === "Refi Breakeven" ?
            <BreakevenAnalysis {...calculations} companyPrimaryColor={companyPrimaryColor} /> :
            <RefinanceAnalysis {...calculations} companyPrimaryColor={companyPrimaryColor} companySecondaryColor={companySecondaryColor} />
        }
      </Grid>
    </div>
  );
};

export default Template;
